/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_11Inputs */



/**
* | output |
* | --- |
* | "Export broadcast dialogue lists" |
*
* @param {Signup_Feature_Pro_11Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_11 = /** @type {((inputs?: Signup_Feature_Pro_11Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_11Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "it") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "es") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
	return /** @type {LocalizedString} */ ("Export broadcast dialogue lists")
});